export default __webpack_public_path__ + "static/media/atcod.4f0854a1.png";